import get from 'lodash.get';
import JsonApi from 'utils/jsonApi';
import { urlComposer } from 'utils/string';
import { expertsTabs } from 'commons/constants';
import type { ExpertObject, GetExpertsRequestPayload, GetExpertsPayload } from 'commons/types';

const { BROWSE } = expertsTabs;

const getBrowseFilter = (searchArray: string[]): string => {
  const filters = searchArray
    .map(
      (word) =>
        `{"name": "name", "op": "ilike", "val": "%25${word}%25"}, {"name": "email", "op": "ilike", "val": "%25${word}%25"}`,
    )
    .join(', ');
  return `[{"or": [${filters}]}]`;
};

export default class Expert {
  jsonApi: JsonApi;

  constructor(jsonApi: JsonApi) {
    this.jsonApi = jsonApi;
  }

  async getAll({ page, search = '', tab }: GetExpertsRequestPayload): Promise<GetExpertsPayload> {
    const searchArray = search.trim().split(' ');
    const fieldsEntity = 'user';
    const fieldsList =
      'affiliation_name,avatar,connection_status,profile,tag_names,entity_obj,tagline';
    const browseFilter = search ? getBrowseFilter(searchArray) : '';
    const myExpertsFilter = `[{"name": "my_network", "op": "eq", "val": true}, {"name":"name","op":"ilike","val":"%25${search}%25"}]`;
    const filter = tab === BROWSE ? browseFilter : myExpertsFilter;
    const urlString = urlComposer('/experts', {
      page,
      filter,
      fieldsEntity,
      fieldsList,
      sorting: 'first_name',
    });
    const response = await this.jsonApi.get(urlString);
    const experts: ExpertObject[] = Object.values(get(response, 'entities.user', {})) as any;
    const count = get(response, 'entities.count', 0);
    return {
      list: experts,
      count,
    };
  }

  async getExpertsCount(): Promise<number> {
    const response = await this.jsonApi.get('/experts?page[number]=1&page[size]=1');
    return get(response, 'entities.count', 0);
  }
}
